"use client";

import { LandscapeAsset as Asset } from "../../../sanity/lib/types/landscapeAsset";
import useIsMobile from "../../hooks/useIsMobile";
import { VideoElement } from "../Video";
import { ImageElement } from "../Image";

interface Props {
    asset: Asset;
    spacing?: "none" | "small";
}

export const LandscapeAsset = ({ asset, spacing }: Props) => {
    const { isMobile } = useIsMobile();

    const hasMobileAsset = !!(asset.mobileAsset && asset.mobileAsset.asset?.[0]);

    return (
        <section
            key={asset.asset.asset?.[0]._key}
            className={`landscape-asset ${spacing && spacing === "small" ? `py-5` : ""}`}
        >
            <div>
                {isMobile && hasMobileAsset ? (
                    asset.mobileAsset?.asset?.[0]._type === "image" ? (
                        <ImageElement
                            width={768}
                            src={asset.mobileAsset.asset[0]}
                            alt={asset.mobileAsset.alt || ""}
                            className="object-cover md:w-full aspect-portrait"
                        />
                    ) : (
                        <VideoElement
                            useIntersection={true}
                            src={asset.mobileAsset?.asset?.[0].assetUrl?.url || ""}
                            className="object-cover md:w-full aspect-portrait"
                            showFrame={asset.mobileAsset?.showVideoFrame}
                        />
                    )
                ) : asset.asset.asset?.[0]._type === "image" ? (
                    <ImageElement
                        style={{ "--custom-asset-ratio": asset.aspectRatio } as React.CSSProperties}
                        width={2560}
                        src={asset.asset.asset[0]}
                        alt={asset.asset.alt || ""}
                        className={`object-cover md:w-full ${asset.aspectRatio ? `aspect-[var(--custom-asset-ratio)]` : "aspect-landscape"}`}
                    />
                ) : (
                    <VideoElement
                        useIntersection={true}
                        src={asset.asset.asset?.[0].assetUrl?.url || ""}
                        className="object-cover md:w-full aspect-landscape"
                        showFrame={asset.asset?.showVideoFrame}
                    />
                )}
            </div>
        </section>
    );
};
